export default "__VITE_ASSET__1d4ed518__"